"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "hashStrings", {
    enumerable: true,
    get: function() {
        return hashStrings;
    }
});
const _crypto = /*#__PURE__*/ _interop_require_default(require("crypto"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function hashStrings(strings) {
    const hasher = _crypto.default.createHash("sha1");
    const anArray = typeof strings === "string" ? [
        strings
    ] : strings;
    const elements = [
        ...anArray
    ];
    elements.sort((a, b)=>a.localeCompare(b));
    elements.forEach((element)=>hasher.update(element));
    return hasher.digest("hex");
}
